import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://lgjzcuhoqifxkajykslg.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnanpjdWhvcWlmeGthanlrc2xnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMjI3NDEsImV4cCI6MjEwMDg5ODc0MX0.uN3behzpgQ8tnx6-Gu-FBK28svERruKhD7HBPi1U_QA'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})